import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img_common_masterdef.png'
import _imports_1 from '../assets/img_common_femaleteadef.png'
import _imports_2 from '../assets/img_common_boystudef.png'
import _imports_3 from '../assets/img_common_girlstudef.png'
import _imports_4 from '@/assets/qwe.png'
import _imports_5 from '../assets/zanwu.png'
import _imports_6 from '@/assets/iphone.png'


const _withScopeId = n => (_pushScopeId("data-v-e8fcf5f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "home"
}
const _hoisted_6 = { class: "name w" }
const _hoisted_7 = { class: "nameleft" }
const _hoisted_8 = { class: "nametouxiang" }
const _hoisted_9 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_10 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_11 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_12 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_13 = { class: "detlid" }
const _hoisted_14 = { class: "detopadd" }
const _hoisted_15 = { class: "detop" }
const _hoisted_16 = {
  key: 0,
  class: "nameright"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nameicon" }, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "tanchuang"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "shutoux" }
const _hoisted_21 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_22 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_23 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_24 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_25 = { class: "nametouxiangs" }
const _hoisted_26 = { class: "debottom" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nameadderleft" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nameadderright" }, "个人中心", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  key: 0,
  class: "boxs w"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "one" }
const _hoisted_33 = { class: "two" }
const _hoisted_34 = { class: "twoleft" }
const _hoisted_35 = { class: "tworight" }
const _hoisted_36 = { class: "there" }
const _hoisted_37 = { class: "thereleft" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thereright" }, "去缴费", -1))
const _hoisted_39 = {
  key: 1,
  class: "null w"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tet" }, "暂无待缴费账单")
], -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = {
  key: 0,
  class: "zanwu"
}
const _hoisted_44 = { class: "zanwutop" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "zanwumain" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_5,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "zanwumain" }, [
    /*#__PURE__*/_createElementVNode("p", null, " 您目前尚未关联学生或教师信息，请打开支付宝搜索“知校企校园”小程序完成相关信息添加。 ")
  ])
], -1))
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "about" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"12px"} }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lianxifs" }, "联系方式", -1))
const _hoisted_50 = { class: "input" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: ""
  })
], -1))
const _hoisted_52 = { class: "input_right" }

import { reactive, ref, onMounted } from "vue";
import { Options, Vue } from "vue-class-component";
import TopNav from "@/components/TopNav.vue";
import TopText from "@/components/TopText.vue";
import { useRouter } from "vue-router";
import { longinApi, userlistApi, educationApi, bindApi } from "@/api/api";
import store from "@/store";
import { generateGuid } from "@/utils/rand";
import { switchApi } from "@/api/api";

import state from "../store";
import { showFailToast } from "vant";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

async function switchSchool() {
  let res: any = await switchApi({ generateGuid: generateGuid(), data });
  if (res.errno == 0) {
    window.location.href = res.data.url;
  }
}

const collapsea: any = ref(false);
const show: any = ref(false);
const educationList: any = ref([]);
const list: any = ref([]);
const active: any = ref(0);
const type: any = ref(1);
const num: any = ref(10);
const offset: any = ref(0);
const Phone: any = ref("");
const data = list.value;
const router = useRouter();
const loading = ref(false);
function detail(value: any) {
  //跳转/acc路由并携带value参数
  router.push({
    path: "/acc",
    query: {
      value: JSON.stringify(value),
    },
  });
}

function goPay(value: any) {
  console.log(value);

  //   // let queryEncode = encodeURIComponent({a:1});
  //   let params = ``;
  console.log(listitem.value.uid);

  window.location.href = `alipays://platformapi/startApp?appId=2021003194656719&page=/pages/payment-details/payment-details&query=a={"uid":"${listitem.value.uid}","uidtype":"${listitem.value.uidtype}","orderid":"${value}"}`; //${encodeURIComponent({uid:listitem.uid,uidtype:listitem.uidtype,orderid:value})}
}
// https://ds.alipay.com/?scheme=
function qiehuan() {
  show.value = !show.value;
}

const getPhone = () => {
  console.log(Phone.value);
};

async function bind() {
  if (Phone.value) {
    let data = {
      mobile: Phone.value,
    };
    let res: any = await bindApi({
      data,
      generateGuid: generateGuid(),
    });
    if (res.errno == 0) {
      collapsea.value = true;
      userlist();
    } else {
    }
  } else {
    showFailToast("手机号不能为空");
  }
}

function huanren(e: any, index: number) {
  active.value = index;
  listitem.value = list.value[active.value];
  show.value = false;
  // console.log(listitem.value);

  education();
}

async function login() {
  const data = {
    // auth_code: "123456789",
    // city_code: "110100",
    // school_name: "河北万旗学校",
    auth_code: state.getters.authCode,
    city_code: state.getters.cityCode,
    school_name:state.getters.campusName ,
  };
  const res: any = await longinApi({ generateGuid: generateGuid(), data });
  if (res.errno == 0) {
    store.commit("SET_TOKEN", res.data.token);
    loading.value = true;
    if (res.data.info.status == 1) {
      collapsea.value = true;
      console.log("SET_TOKEN");

      userlist();
    }
  }
}
const listitem: any = ref("");
async function userlist() {
  const res: any = await userlistApi({ generateGuid: generateGuid() });
  if (res.errno == 0) {
    if(res.data){
list.value = res.data;
    listitem.value = res.data[active.value];
    education();
    }
    
  }
}

async function education() {
  // console.log(list.value[active.value]);

  const data = {
    uid: list.value[active.value].uid,
    uidtype: list.value[active.value].uidtype,
    type: type.value,
    num: num.value,
    offset: offset.value,
  };
  const res: any = await educationApi({ generateGuid: generateGuid(), data });
  if (res.errno == 0) {
    educationList.value = res.data.data;
    console.log(educationList.value);
  }
}

if (state.getters.shou) {
  store.commit("SET_SHOU", false);
  console.log(state.getters.shou);

  login();
} else {
  loading.value = true;
  collapsea.value = true;
  userlist();
}
function handleUpdateMessage(newMessage: any) {
  console.log(12);
}

// @Options({
//   components: {
//     TopNav,
//     TopText,
//   },
// })
// export default class HomeView extends Vue {}

return (_ctx: any,_cache: any) => {
  return (!loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (collapsea.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (list.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (collapsea.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(TopNav, {
                            back: true,
                            text: "智慧校园",
                            clone: 0,
                            color: "#FFFFFF"
                          }),
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                (listitem.value.uidtype == 1 && listitem.value.gender == 'M')
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                                  : _createCommentVNode("", true),
                                (listitem.value.uidtype == 1 && listitem.value.gender == 'F')
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                                  : _createCommentVNode("", true),
                                (listitem.value.uidtype == 2 && listitem.value.gender == 'M')
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                                  : _createCommentVNode("", true),
                                (listitem.value.uidtype == 2 && listitem.value.gender == 'F')
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("div", _hoisted_15, _toDisplayString(listitem.value.name), 1),
                                  (list.value.length > 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _hoisted_17,
                                        _createElementVNode("div", {
                                          class: "titles",
                                          onClick: _cache[0] || (_cache[0] = ($event: any) => (qiehuan()))
                                        }, "切换"),
                                        (show.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  class: "boxsitems",
                                                  key: index,
                                                  onClick: ($event: any) => (huanren(item, index))
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: "shu",
                                                    style: _normalizeStyle(
                        active.value == index
                          ? 'background: linear-gradient(180deg, #5a9ffd 0%, #46d4d6 100%);'
                          : ''
                      )
                                                  }, null, 4),
                                                  _createElementVNode("div", _hoisted_20, [
                                                    (item.uidtype == 1 && item.gender == 'M')
                                                      ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                                                      : _createCommentVNode("", true),
                                                    (item.uidtype == 1 && item.gender == 'F')
                                                      ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                                                      : _createCommentVNode("", true),
                                                    (item.uidtype == 2 && item.gender == 'M')
                                                      ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                                                      : _createCommentVNode("", true),
                                                    (item.uidtype == 2 && item.gender == 'F')
                                                      ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_25, _toDisplayString(item.name), 1)
                                                ], 8, _hoisted_19))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_26, _toDisplayString(listitem.value.schoolname), 1)
                              ])
                            ]),
                            _createElementVNode("div", {
                              class: "namesadder",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (detail(listitem.value)))
                            }, _hoisted_29)
                          ]),
                          (educationList.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createVNode(TopText, { text: "教育缴费" }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(educationList.value, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "conters",
                                    key: index,
                                    onClick: ($event: any) => (goPay(item.orderid))
                                  }, [
                                    _createElementVNode("div", _hoisted_32, _toDisplayString(item.ordername), 1),
                                    _createElementVNode("div", _hoisted_33, [
                                      _createElementVNode("div", _hoisted_34, _toDisplayString(listitem.value.name), 1),
                                      _createElementVNode("div", _hoisted_35, "￥ " + _toDisplayString(item.amount_total), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_36, [
                                      _createElementVNode("div", _hoisted_37, "缴费截止时间：" + _toDisplayString(item.validity), 1),
                                      _hoisted_38
                                    ])
                                  ], 8, _hoisted_31))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    (collapsea.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createVNode(TopNav, {
                              back: true,
                              text: "智慧校园",
                              color: "#333333"
                            })
                          ]),
                          _hoisted_45,
                          _createElementVNode("div", {
                            class: "zanwubut",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (switchSchool()))
                          }, "切换学校")
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(TopNav, {
                  back: true,
                  text: "",
                  color: "#333333"
                })
              ]),
              _hoisted_48,
              _hoisted_49,
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "",
                    id: "",
                    placeholder: "请输入注册学校时预留的联系方式",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((Phone).value = $event)),
                    onChange: getPhone
                  }, null, 544), [
                    [_vModelText, Phone.value]
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (bind()))
              }, "绑定"),
              _createElementVNode("div", {
                class: "button1",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (switchSchool()))
              }, "切换学校")
            ]))
      ]))
}
}

})